import { render, staticRenderFns } from "./PFMigrationDateSettings.vue?vue&type=template&id=328bf6fb"
import script from "./PFMigrationDateSettings.vue?vue&type=script&lang=js"
export * from "./PFMigrationDateSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports